module.exports = __webpack_public_path__ + "img/caselist29.01a12181.jpg";